function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useCallback } from 'react';
import { withTheme } from '../../core/theming';
import { ScrollView as RNScrollView, View, StyleSheet } from 'react-native';

const ScrollView = props => {
  const {
    onScroll: onScrollProps,
    style: styleProps,
    children,
    theme: {
      colors
    },
    isBorderEnabled = true,
    scrollRef
  } = props;
  const [isShowingBorder, setShowingBorder] = useState(false);
  const [scrollViewContentHeight, setScrollViewContentHeight] = useState(0);
  const onScroll = useCallback(e => {
    var _e$nativeEvent, _e$nativeEvent$conten, _e$nativeEvent2, _e$nativeEvent2$conte, _e$nativeEvent3, _e$nativeEvent3$layou;

    const y = -(e === null || e === void 0 ? void 0 : (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : (_e$nativeEvent$conten = _e$nativeEvent.contentOffset) === null || _e$nativeEvent$conten === void 0 ? void 0 : _e$nativeEvent$conten.y) || 0;
    const contentHeight = (e === null || e === void 0 ? void 0 : (_e$nativeEvent2 = e.nativeEvent) === null || _e$nativeEvent2 === void 0 ? void 0 : (_e$nativeEvent2$conte = _e$nativeEvent2.contentSize) === null || _e$nativeEvent2$conte === void 0 ? void 0 : _e$nativeEvent2$conte.height) || 0;
    const scrollViewHeight = (e === null || e === void 0 ? void 0 : (_e$nativeEvent3 = e.nativeEvent) === null || _e$nativeEvent3 === void 0 ? void 0 : (_e$nativeEvent3$layou = _e$nativeEvent3.layoutMeasurement) === null || _e$nativeEvent3$layou === void 0 ? void 0 : _e$nativeEvent3$layou.height) || 0;
    const isShowing = contentHeight + y >= scrollViewHeight;
    setShowingBorder(isShowing);

    if (onScrollProps) {
      onScrollProps(e);
    }
  }, [onScrollProps]);

  const onLayout = e => {
    var _e$nativeEvent4, _e$nativeEvent4$layou;

    const height = (e === null || e === void 0 ? void 0 : (_e$nativeEvent4 = e.nativeEvent) === null || _e$nativeEvent4 === void 0 ? void 0 : (_e$nativeEvent4$layou = _e$nativeEvent4.layout) === null || _e$nativeEvent4$layou === void 0 ? void 0 : _e$nativeEvent4$layou.height) || 0;
    setShowingBorder(height < scrollViewContentHeight);
  };

  const onContentSizeChange = (_, h) => {
    setScrollViewContentHeight(h);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RNScrollView, _extends({}, props, {
    ref: scrollRef,
    style: styleProps,
    scrollEventThrottle: 16,
    onScroll: onScroll,
    onContentSizeChange: onContentSizeChange,
    onLayout: onLayout
  }), children), isBorderEnabled && /*#__PURE__*/React.createElement(View, {
    style: [styles.bottomBorder, {
      backgroundColor: colors.line.default,
      opacity: isShowingBorder ? 1 : 0
    }]
  }));
};

const styles = StyleSheet.create({
  bottomBorder: {
    width: '100%',
    height: 1
  }
});
export default withTheme(ScrollView);
//# sourceMappingURL=index.js.map